import React, { useState, useEffect } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// Importando as fontes necessárias para o pdfMake
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const PrintToPDF = ({ headers, data, docTitle, hasMonth, footerValues, fontHeader, fontData, fixedSize, observacoes }) => {

    /**
     * Calcula o tamanho da fonte baseado no número de colunas
     */
    const calculateFontSize = (length) => {
        if (length < 4) {
            return 11
        }
        if (length < 6) {
            return 10
        }
        if (length < 8) {
            return 9
        }
        return 8; // Tamanho para muitas colunas
    };

    /**
     * Calcula a largura ideal das colunas baseada no conteúdo
     */
    const calculateColumnWidths = (headers, data, isLandscape) => {
        if (fixedSize) {
            const availableWidth = isLandscape ? 700 : 450;
            const columnWidth = availableWidth / headers.length;
            return headers.map(() => columnWidth);
        }

        // Larguras específicas para o contexto de patrimônios (reduzidas para caber melhor)
        const specificWidths = {
            'Marca': 80,
            'Modelo': 80, 
            'Valor': 60,
            'Ações': 50
        };

        // Calcular larguras baseadas no conteúdo ou usar larguras específicas
        const columnWidths = headers.map((header, index) => {
            // Usar largura específica se definida
            if (specificWidths[header.label]) {
                return specificWidths[header.label];
            }

            // Calcular largura baseada no cabeçalho
            let headerWidth = Math.max(header.label.length * 8, 80);

            // Calcular largura baseada no conteúdo das células (primeiras 5 linhas para performance)
            let maxContentWidth = headerWidth;
            const sampleData = data.slice(0, 5);
            
            sampleData.forEach(item => {
                const cellContent = String(item[header.key] || '');
                const contentWidth = Math.max(cellContent.length * 6, 80);
                maxContentWidth = Math.max(maxContentWidth, contentWidth);
            });

            return Math.min(maxContentWidth, 150);
        });

        return columnWidths;
    };

    /**
     * Determina se deve usar orientação paisagem
     */
            const shouldUseLandscape = (headers, data) => {
        // Para Patrimônios sempre usar paisagem pois tem 4 colunas
        if (headers.length >= 4) return true;

        // Calcular estimativa simples de largura
        const estimatedWidth = headers.reduce((sum, header) => {
            return sum + Math.max(header.label.length * 8, 80);
        }, 0);

        // Se a largura estimada exceder 350 pontos, usar paisagem
        return estimatedWidth > 350;
    };

         /**
      * Formatar item conforme tipo
      */
     // Função showItem removida pois o processamento é feito antes na transformação dos dados

    const handlePrintPDF = () => {
        // Filtrar headers válidos
        const validHeaders = headers.filter((header) => header);

        if (!data || data.length === 0) {
            alert('Não há dados para gerar o PDF');
            return;
        }

        if (!validHeaders || validHeaders.length === 0) {
            alert('Não há cabeçalhos definidos para a tabela');
            return;
        }

        const logoUrl = "data:image/png;base64,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"; // Nome do arquivo do logotipo da empresa


        // Transformar dados das colunas de moeda ANTES de gerar o PDF
        const transformedData = data.map(item => {
            const newItem = { ...item };
            
            // Verificar se há colunas de moeda para transformar
            validHeaders.forEach(header => {
                if (header.type === 'money' && header.key && newItem[header.key]) {
                    let value = newItem[header.key];
                    
                    // Se já está formatado como moeda brasileira, não mexer
                    if (typeof value === 'string' && value.includes('R$')) {
                        return;
                    }
                    
                    // Converter valor para número e depois para formato BR
                    let numericValue;
                    if (typeof value === 'string') {
                        // Remove espaços e converte vírgula para ponto se necessário
                        numericValue = parseFloat(value.replace(/\s/g, '').replace(',', '.'));
                    } else {
                        numericValue = parseFloat(value);
                    }
                    
                    // Se é um número válido, formatar como moeda brasileira
                    if (!isNaN(numericValue)) {
                        newItem[header.key] = new Intl.NumberFormat('pt-BR', { 
                            style: 'currency', 
                            currency: 'BRL' 
                        }).format(numericValue);
                    }
                }
            });
            
            return newItem;
        });

        // Determinar orientação e calcular larguras
        const isLandscape = shouldUseLandscape(validHeaders, transformedData);
        const columnWidths = calculateColumnWidths(validHeaders, transformedData, isLandscape);

        // Distribuir larguras para caber todos os dados
        const totalWidth = columnWidths.reduce((sum, width) => sum + width, 0);
        const maxPageWidth = isLandscape ? 720 : 450; // Mais conservativo

        let finalWidths;
        if (fixedSize) {
            // Distribuir igualmente quando fixedSize é true
            const equalWidth = maxPageWidth / validHeaders.length;
            finalWidths = validHeaders.map(() => equalWidth);
        } else if (totalWidth > maxPageWidth) {
            // Escalar para caber na página
            const scale = maxPageWidth / totalWidth;
            finalWidths = columnWidths.map(width => Math.max(width * scale, 40));
        } else {
            finalWidths = columnWidths;
        }

        const docDefinition = {
            content: [
                {
                    columns: [
                        {
                            image: logoUrl,
                            width: 100,
                        },
                        hasMonth && {
                            text: `Mês de referência: ${hasMonth}`,
                            style: "subHeader",
                            alignment: "right",
                        },
                    ],
                },
                // Título da tabela
                { text: docTitle, style: "header" },
                {
                    table: {
                        headerRows: 1,
                        widths: finalWidths,
                        margin: [0, 50, 50, 0],
                        body: [
                            validHeaders.map((header) => ({ text: header.label, style: 'tableHeader' })),
                            ...transformedData.map((item) =>
                                validHeaders.map((header) =>
                                    header?.actions
                                        ? ''
                                        : {
                                            text: item[header.key] || '',
                                            style: 'tableBody'
                                        }
                                )
                            ),
                        ],
                    },
                                         layout: {
                         fillColor: function (rowIndex, node, columnIndex) {
                             return (rowIndex === 0) ? '#f3f3f3' : null;
                         },
                         hLineWidth: function (i, node) {
                             return (i === 0 || i === node.table.body.length) ? 1 : 0.5;
                         },
                         vLineWidth: function (i, node) {
                             return (i === 0 || i === node.table.widths.length) ? 1 : 0.5;
                         },
                         hLineColor: function (i, node) {
                             return '#DDDDDD';
                         },
                         vLineColor: function (i, node) {
                             return '#DDDDDD';
                         },
                                                 paddingLeft: function(i, node) { return 3; },
                        paddingRight: function(i, node) { return 3; },
                        paddingTop: function(i, node) { return 3; },
                        paddingBottom: function(i, node) { return 3; }
                     }
                },
                // Campo de Observações antes do rodapé de preços
                observacoes && {
                    text: [
                        { text: 'Observações: ', bold: true },
                        { text: observacoes }
                    ],
                    style: 'observacoes',
                    margin: [0, 20, 0, 10]
                },
                // Adicionando o rodapé
                footerValues && footerValues.length > 0 && footerValues.map((footer) => ({ text: footer, style: "footer" })),
            ],
            styles: {
                header: {
                    fontSize: 22,
                    bold: true,
                    margin: [0, 0, 0, 20],
                    alignment: "center",
                },
                tableHeader: {
                    bold: true,
                    fontSize: fontHeader || Math.max(calculateFontSize(validHeaders.length), 9),
                    fillColor: "#f3f3f3",
                    alignment: "center",
                },
                                 tableBody: {
                     fontSize: fontData || Math.max(calculateFontSize(validHeaders.length), 8),
                     alignment: "center", // Alinhamento centralizado
                     noWrap: false, // Permitir quebra de linha
                     vAlign: "middle", // Alinhamento central vertical
                     margin: [2, 3, 2, 3], // Margens reduzidas
                 },
                subHeader: {
                    fontSize: 20,
                    bold: true,
                    margin: [0, 0, 0, 10],
                },
                footer: {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 10, 0, 0],
                    alignment: "right",
                    fillColor: "#f3f3f3",
                },
                observacoes: {
                    fontSize: 13,
                    margin: [0, 10, 0, 10],
                    color: '#222',
                    alignment: 'left',
                    italics: false,
                    background: '#f7f7f7',
                    border: [false, false, false, false],
                },
            },
            pageSize: "A4",
            pageOrientation: isLandscape ? "landscape" : "portrait",
            pageMargins: [10, 10, 10, 10], // Margens reduzidas para mais espaço aos dados
        };

        pdfMake.createPdf(docDefinition).open();
    };

    return (
        <button
            onClick={handlePrintPDF}
            className="inline-flex items-center justify-center px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 min-w-[120px]"
        >
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clipRule="evenodd" />
            </svg>
            Gerar PDF
        </button>
    );
};

export default PrintToPDF;